<template>
  <container id="biancaEluisa" class="mt-12">
    <content-component :order1lg="'order-2'" :order2lg="'order-1'" :order1sm="'order-1'" :order2sm="'order-2'">

      <title-component title="Dra Bianca Eluisa Robetti Gonoratto"
                       sub-title="Conheça um pouco mais sobre mim e minha formação acadêmica"/>

      <template #slot1>
        <div class="flex flex-col items-center">
          <img src="../../public/bianca-eluisa.png" alt="" width="430" height="600" class="rounded-lg">

          <primary-button class="hidden lg:block w-md mt-6" title="Agende sua pré consulta gratuita"/>
        </div>
      </template>
      <template #slot2>
        <div class="bg-[#00BBDE] p-4 mt-12 rounded-lg">
          <div
              class="mt-8 flex text-center lg:text-start justify-center py-4 gap-x-4 items-center bg-gradient-to-r from-[#00BADE] to-[#00DFDE] text-white shadow-lg rounded-2xl">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                 stroke="currentColor" class="size-6 hidden lg:block">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
            </svg>

            <span class="text-xl font-bold px-4 lg:px-0">Mais de 500 Atendimentos Realizados</span>
          </div>

          <div class="my-12">
            <ul
                class="relative flex flex-col gap-2 py-6 pl-8 before:absolute before:top-0 before:left-8 before:h-full before:border before:-translate-x-1/2 before:border-slate-200 before:border-dashed after:absolute after:top-6 after:left-8 after:bottom-4 after:border after:-translate-x-1/2 after:border-slate-200 "
                v-for="(course, index) in courses" :key="index"
            >
              <li class="relative pl-8">
                <div class="flex flex-col flex-1 gap-4">
                  <div
                      class="absolute z-10 inline-flex items-center justify-center rounded-full p-2 -left-5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white"
                         class="bi bi-mortarboard" viewBox="0 0 16 16">
                      <path
                          d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917zM8 8.46 1.758 5.965 8 3.052l6.242 2.913z"/>
                      <path
                          d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466zm-.068 1.873.22-.748 3.496 1.311a.5.5 0 0 0 .352 0l3.496-1.311.22.748L8 12.46z"/>
                    </svg>
                  </div>
                  <p class="flex flex-col items-start text-lg font-medium leading-8 lg:items-center md:flex-row">
                    <span class="flex-1 text-white font-bold text-lg">{{ course }}
                    </span>
                  </p>
                </div>
              </li>
            </ul>
            <div class="mt-12 px-4">
              <p class="text-lg lg:text-sm text-white leading-5">
                “Busco em meu trabalho ajudar a descobrir a causa de suas dores tratando-as com o toque das mãos e
                proporcionando um melhor resultado para funcionamento do seu corpo. “
                <span class="text-blue-600">– (Bianca Eluisa Robetti Gonoratto)</span>
              </p>
            </div>
          </div>
          <div class="lg:hidden w-full mt-12 mb-12 flex justify-center items-center">
            <primary-button title="Agende sua pré consulta gratuita"/>
          </div>
        </div>
      </template>
    </content-component>
  </container>
</template>
<script>
import Container from "@/components/partials/Container.vue";
import TitleComponent from "@/components/TitleComponent.vue";
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";
import ContentComponent from "@/components/partials/Content.vue";

export default {
  name: "BiancaEluisaComponent",
  components: {ContentComponent, PrimaryButton, TitleComponent, Container: Container},
  data() {
    return {
      courses: [
        "Fisioterapeuta Graduada pela Unidep",
        "Especialista em Terapia Neurofasciogenica",
        "Curso de Embriologia e Filogenética do Sistema Fascial",
        "Curso Internacional de Emoções nas disfunções somáticas",
        "Curso Internacional em Cinesiologia aplicada"
      ]
    }
  }
}
</script>